// Phone formatting helpers — canonical display format: XXX-XXX-XXXX
//
// Inputs we tolerate (anything users type / paste):
//   "+1 (305) 555-1234", "305.555.1234", "3055551234", "+13055551234", "555-1234", "12 3456 7890", "" / null
//
// formatPhone(value):
//   - 10 digits → "305-555-1234"
//   - 11 digits starting with 1 (US country code) → drop leading 1 → "305-555-1234"
//   - 7 digits (local) → "555-1234"
//   - otherwise → original input (trimmed)

export function digitsOnly(value) {
  if (value == null) return "";
  return String(value).replace(/\D+/g, "");
}

export function formatPhone(value) {
  if (value == null || value === "") return "";
  const d = digitsOnly(value);
  if (d.length === 11 && d.startsWith("1")) {
    return `${d.slice(1, 4)}-${d.slice(4, 7)}-${d.slice(7)}`;
  }
  if (d.length === 10) {
    return `${d.slice(0, 3)}-${d.slice(3, 6)}-${d.slice(6)}`;
  }
  if (d.length === 7) {
    return `${d.slice(0, 3)}-${d.slice(3)}`;
  }
  return String(value).trim();
}

// Live formatter for <input> fields — formats progressively as the user types.
// Always returns at most 12 chars (XXX-XXX-XXXX).
export function formatPhoneInput(value) {
  let d = digitsOnly(value);
  if (d.length === 11 && d.startsWith("1")) d = d.slice(1);
  d = d.slice(0, 10);
  if (d.length <= 3) return d;
  if (d.length <= 6) return `${d.slice(0, 3)}-${d.slice(3)}`;
  return `${d.slice(0, 3)}-${d.slice(3, 6)}-${d.slice(6)}`;
}
